<template>
  <base-dialog class="save-role-dialog" width="485px" :visible.sync="visible" show-close>
    <template v-slot:header>设置关联项目</template>
    <el-form label-width="80px" label-position="left">
      <el-form-item label="项目">
        <el-select v-model="curProjectId">
          <el-option
            v-for="project in projects"
            :key="project.id"
            :label="project.name"
            :value="project.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="close">取 消</base-button>
        <base-button type="primary" @click="submit">确 定</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import * as ProjectApi from "@/api/project/project"
import * as SheetApi from "@/api/sheet/sheetData"

export default {
  name: "SetRelatedProjectDialog",
  props: {
    sheetId: String,
    sheetDataId: String,
    projectId: String
  },
  components: {
    BaseDialog,
    BaseButton
  },
  data() {
    return {
      visible: false,
      curProjectId: null,
      projects: []
    }
  },
  created() {
    ProjectApi.getProjectList({ cache: true }).then(res => (this.projects = res))
  },
  methods: {
    open() {
      this.$nextTick(() => {
        this.curProjectId = this.projectId
        this.visible = true
      })
    },
    close() {
      this.curProjectId = ""
      this.visible = false
    },
    submit() {
      SheetApi.setSheetDataProject(this.sheetId, this.sheetDataId, this.curProjectId).then(() => {
        this.$message.success("操作成功")
        this.$emit("change")
        this.close()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.save-role-dialog {
  .el-form {
    margin-top: 18px;
    ::v-deep {
      .el-form-item__content {
        display: flex;
        .el-select {
          flex: 1;
        }
      }
    }
  }
}
</style>
